import React from 'react'
import { useMediaQuery, useTheme } from "@mui/material";

// Create a custom hook that follows React hooks rules
export const useIsSmallScreen = () => {
  const theme = useTheme();
  const isSmallSize = useMediaQuery(theme.breakpoints.down("sm"));
  return isSmallSize;
};

// Keep the old function for backward compatibility but make it non-hook
export const IsSmallScreen = () => {
  // This should not be used as it violates hooks rules
  // Use useIsSmallScreen hook instead
  return false; // Default fallback
};
